import React, { Component } from 'react';
import { Stack, Type } from 'react-spark';
import config from '../../../../config';
import { PhoneIcon, MailIcon } from '../../icons';
import { FONT_SIZES } from '../../../../utils/novaTypography';

const { phone, email } = config.global.company;

export class OffersV3Help extends Component {
    render() {
        return (
            <div>
                <Type.BodyTwo className="sprk-u-pbs sprk-u-mvn" style={{ fontSize: FONT_SIZES.body }}>
                    Need help?
                </Type.BodyTwo>
                
                <div className="offers-v3-help__contact-container">
                    <div className="offers-v3-help__contact-item sprk-u-pbm">
                        <PhoneIcon width={24} height={24} />
                        <Type.BodyTwo className="sprk-u-man" style={{ fontSize: FONT_SIZES.body }}>
                            Call{' '}
                            <a 
                                className="sprk-u-Color--inherit" 
                                href={`tel:${phone.dash}`}
                            >
                                {phone.long}
                            </a>
                        </Type.BodyTwo>
                    </div>
                    
                    <div className="offers-v3-help__contact-item">
                        <MailIcon width={24} height={24} />
                        <Type.BodyTwo className="sprk-u-man" style={{ fontSize: FONT_SIZES.body }}>
                            <a 
                                className="sprk-u-Color--inherit" 
                                href={`mailto:${email.support}`}
                            >
                                {email.support}
                            </a>
                        </Type.BodyTwo>
                    </div>
                </div>
            </div>
        );
    }
}
